import client, {encode} from "utils/api";
import store from 'utils/store'
import { normalize, schema } from 'normalizr';


function getStories(account, filters, toStore=true){
  return client().get("/accounts/"+account.id+"/stories?"+encode(filters))
    .then((response) => {
      if(toStore){
        const story = new schema.Entity('stories');
        const normalizedData = normalize(response.data, [story]);
        store.dispatch({
          type:"ADD_STORIES",
          payload: {
            data: normalizedData,
            account:account.id
          }
        })
      }
      return response.data
    })
    .catch(e => {
      //console.log("==>", e.response)
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}


export default {
  getStories
}



// WEBPACK FOOTER //
// ./src/components/account_page/api.js